export default __webpack_public_path__ + "static/media/large.608f8c37.jpg";